import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  private duration = 3000;

  constructor(private snackBar: MatSnackBar) {}


  /* Success */
  success(message: string, duration?: number) {

    this.snackBar.open(
      message,
      'Close',
      {
        duration: duration || this.duration,
        panelClass: ['snackbar-success'],
        horizontalPosition: 'right',
        verticalPosition: 'top'
      }
    );
  }


  /* Error */
  error(message: string, duration?: number) {

    this.snackBar.open(
      message,
      'Close',
      {
        duration: duration || this.duration,
        panelClass: ['snackbar-error'],
        horizontalPosition: 'right',
        verticalPosition: 'top'
      }
    );
  }


  /* Warning */
  warning(message: string, duration?: number) {

    this.snackBar.open(
      message,
      'Close',
      {
        duration: duration || this.duration,
        panelClass: ['snackbar-warning'],
        horizontalPosition: 'right',
        verticalPosition: 'top'
      }
    );
  }


  /* Info */
  info(message: string, duration?: number) {

    this.snackBar.open(
      message,
      'Close',
      {
        duration: duration || this.duration,
        panelClass: ['snackbar-info'],
        horizontalPosition: 'right',
        verticalPosition: 'top'
      }
    );
  }

}
